import { Action } from '../../../actions';
import { StoreState } from '../../../reducers';
import { Dispatch } from 'react-redux';

enum GDPRCookieActionKeys {
	SET_IS_DISPLAYED = '@@GDPRCookieAction/SET_IS_DISPLAYED',
}

type GDPRCookieAction = SetIsDislayedAction;

interface SetIsDislayedAction extends Action {
	type: GDPRCookieActionKeys.SET_IS_DISPLAYED;
	isDisplayed: boolean;
}

const closeGDPRBanner = () =>
	(dispatch: Dispatch<StoreState>): void => {
		dispatch({
			type: GDPRCookieActionKeys.SET_IS_DISPLAYED,
			isDisplayed: false,
		});
	};

const openGDPRBanner = () =>
	(dispatch: Dispatch<StoreState>): void => {
		dispatch({
			type: GDPRCookieActionKeys.SET_IS_DISPLAYED,
			isDisplayed: true,
		});
	};

export {
	GDPRCookieActionKeys,
	GDPRCookieAction,
	closeGDPRBanner,
	openGDPRBanner,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CookieNotification/GDPRCookie/actions.ts